var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3796 7.85624C18.3096 7.84624 18.2396 7.84624 18.1696 7.85624C16.6196 7.80624 15.3896 6.53624 15.3896 4.97624C15.3896 3.38624 16.6796 2.08624 18.2796 2.08624C19.8696 2.08624 21.1696 3.37624 21.1696 4.97624C21.1596 6.53624 19.9296 7.80624 18.3796 7.85624Z",
    fill: "#DCDCDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6392 14.7862C20.5192 15.5362 18.9492 15.8162 17.4992 15.6262C17.8792 14.8062 18.0792 13.8962 18.0892 12.9362C18.0892 11.9362 17.8692 10.9862 17.4492 10.1562C18.9292 9.95622 20.4992 10.2362 21.6292 10.9862C23.2092 12.0262 23.2092 13.7362 21.6392 14.7862Z",
    fill: "#DCDCDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28977 7.85624C7.35977 7.84624 7.42977 7.84624 7.49977 7.85624C9.04977 7.80624 10.2798 6.53624 10.2798 4.97624C10.2798 3.37624 8.98977 2.08624 7.38977 2.08624C5.79977 2.08624 4.50977 3.37624 4.50977 4.97624C4.50977 6.53624 5.73977 7.80624 7.28977 7.85624Z",
    fill: "#DCDCDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39973 12.9362C7.39973 13.9062 7.60973 14.8262 7.98973 15.6562C6.57973 15.8062 5.10973 15.5062 4.02973 14.7962C2.44973 13.7462 2.44973 12.0362 4.02973 10.9862C5.09973 10.2662 6.60973 9.97622 8.02973 10.1362C7.61973 10.9762 7.39973 11.9262 7.39973 12.9362Z",
    fill: "#DCDCDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9694 15.9562C12.8894 15.9462 12.7994 15.9462 12.7094 15.9562C10.8694 15.8962 9.39941 14.3862 9.39941 12.5262C9.40941 10.6262 10.9394 9.08624 12.8494 9.08624C14.7494 9.08624 16.2894 10.6262 16.2894 12.5262C16.2794 14.3862 14.8194 15.8962 12.9694 15.9562Z",
    fill: "#DCDCDC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71941 18.0263C8.20941 19.0363 8.20941 20.6963 9.71941 21.6963C11.4394 22.8463 14.2594 22.8463 15.9794 21.6963C17.4894 20.6863 17.4894 19.0263 15.9794 18.0263C14.2694 16.8763 11.4494 16.8763 9.71941 18.0263Z",
    fill: "#DCDCDC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.3d56abb1.svg";
export { ForwardRef as ReactComponent };